/* eslint-disable prettier/prettier */
import {
  reactive,
  toRefs,
  provide,
  ref,
  nextTick,
  onMounted,
  computed,
  onBeforeUnmount
} from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import CarTypeCard from '@/components/shoppingCart/CarTypeCard'
import bottom from '@/components/shoppingCart/bottom'
import ConfirmTyre from '@/components/shoppingCart/ConfirmTyre'
import ConfirmGoods from '@/components/common/ConfirmGoods'
import { getShoppingList, deleteShoppingInf, deleteEWShopping } from '@/api/shoppingCar'
import { couponList, setConfirmGoodsStore } from '@/util/shoppingCar/handle'
import { isNum } from '@/util/index'
import Loading from '@/components/common/Loading.vue'
import _ from 'lodash'
import { showToast } from '@/util/couponCollection'
import { Math } from 'core-js'

export default {
  components: {
    CarTypeCard,
    ConfirmGoods,
    ConfirmTyre,
    bottom,
    Loading
  },
  setup() {
    const router = useRouter()
    const store = useStore()
    const palnTypeCardRef = ref()
    const tyreTypeCardRef = ref()
    const shopTypeCardRef = ref()
    const tyrePlanCardRef = ref()
    const state = reactive({
      goodNum: 0,
      showNum: 0,
      showTyreNum: 0,
      showTyrePlanNum: 0,
      planData: {},
      tyreData: {},
      tyrePlanData: {},
      shopData: {},
      selectAllGoods: false,
      isManage: false,
      result: { planData: [], tyreData: [],tyrePlanData:[], shopData:[] },
      confirmGoodData: {},
      isShowDialog: false,
      isShowErrDialog: false,
      errDialogMsg: '',
      totalPrice: 0,
      totalProductAmount: 0,
      loyaltyId: '',
      isShowLoad: true,
      isShowNoData: false,
      dividerStyle: { color: '#ddd', borderColor: '#ccc', padding: '0 16px' },
      isShowDiscount: false,
      couponListParam: null
    })
    // 设置经销商参加活动标识
    store.dispatch('setDealerJoinPlanFlag', true)
    // 点击去结算
    const toBalance = ({ data, notUseCoupon }) => {
      const { result, totalPrice, totalProductAmount } = state
      let validateRes = validate()
      if (!validateRes) return
      let currentBuyProductInfo = {}
      let path = ''
      let query = null
      // 购买计划
      let intention = false
      if (result.planData && result.planData.length) {
        let planData = result.planData.map((item) => {
          const carInfoObj = item._data.carInfo || {}
          let selfPrice = isNum(item._data.selfPrice) ? item._data.selfPrice : item._data.uniformPrice
          //新增 意向金标识符
          if(item._data.payTypeFlag==3){
            carInfoObj.intention = true
            selfPrice = item.depositPrice
            intention = true
          }
          return {
            ...item,
            price: item._data.uniformPrice,
            selfPrice,
            carInfoObj,
            dealerInfo: item._data.dealerInfo || {}
          }
        })
        currentBuyProductInfo = { intention, planData, totalPrice, totalProductAmount }
        path = '/confirmOrder'
        query = { from: 'shoppingCarList',event: '致友计划下单' }
      }
      // 购买轮胎包计划
      if (result.tyrePlanData && result.tyrePlanData.length) {
        let tyrePlanData = result.tyrePlanData.map((item) => {
          const carInfoObj = item._data.carInfo || {}
          let selfPrice = isNum(item._data.selfPrice) ? item._data.selfPrice : item._data.uniformPrice
          //新增 意向金标识符
          if(item._data.payTypeFlag==3){
            carInfoObj.intention = true
            selfPrice = item.depositPrice
            intention = true
          }
          return {
            ...item,
            price: item._data.uniformPrice,
            selfPrice,
            carInfoObj,
            dealerInfo: item._data.dealerInfo || {}
          }
        })

        currentBuyProductInfo = { intention,tyrePlanData, totalPrice, totalProductAmount }
        path = '/confirmOrder'
        query = { from: 'shoppingCarList',event: '轮胎包计划下单' }
      }
      // 购买轮胎
      if (result.tyreData && result.tyreData.length) {
        currentBuyProductInfo = result.tyreData.map((item) => {
          return {
            ...item,
            ...item._data,
            id: item._data.productId,
            cartId: item.id,
            productPrice: item.price,
            msrp: item.price,
            count: item.num,
            load_index: item.loadIndex,
            speed_rating: item.speedRating,
            extra_load: item.extraLoad,
            ind_price: item.indPrice
          }
        })
        // 优惠券数据
        let selectCoupon = []
        if (data.length) {
          selectCoupon = data.map(({ _flag }) => _flag)
        }
        path = '/createOrder'
        query = { from: 'carPage', gs_code: result.tyreData[0]['gsCode'], event: '轮胎下单' }
        selectCoupon.length && (query.shoppingCoupon = selectCoupon.join())
        notUseCoupon && (query.notUseCoupon = true)
      }
      // 购买商城商品
      if (result.shopData && result.shopData.length) {
        path = '/confirmDirectSalesOrder'
        if (result.shopData[0].isEW) {
          const ewShopDetail = result.shopData[0]
          currentBuyProductInfo = {
            shopData: {
              product: {
                carInfo: {
                  id: ewShopDetail._data.customerCarId,
                  baumuster: ewShopDetail._data.baumuster
                },
                gsCode: ewShopDetail._data.gsCode,
                productId: ewShopDetail._data.productId
              }
            },
            cartId: ewShopDetail.id
          }
          query = { from: 'ewShoppingCarList',event: '商城商品下单' }
        } else {
          let shopData = result.shopData.map((item) => ({
            ...item,
            price: item._data.uniformPrice,
            selfPrice: isNum(item._data.selfPrice) ? item._data.selfPrice : item._data.uniformPrice,
            carInfoObj: item._data.carInfo || {},
            dealerInfo: item._data.dealerInfo || {}
          }))
          currentBuyProductInfo = { shopData, totalPrice, totalProductAmount }
          query = { from: 'shoppingCarList',event: '商城商品下单' }
        }
      }
      // 缓存商品信息
      store.dispatch('setCurrentBuyProductInfo', currentBuyProductInfo)
      path && router.push({ path, query })
    }
    // 校验函数
    const validate = () => {
      const { result, totalProductAmount } = state
      let errDialogMsg = ''
      if (totalProductAmount === 0) {
        showToast('请选择要结算的商品')
        return
      }
      // console.log("result-->", result);
      const { tyreData = [],tyrePlanData=[], planData = [],shopData = [] } = result
      // 如果有0元和非0元的计划在购物车合并下单时 就提示分开下单
      if (planData.length > 1) {
        let hasZero = false
        let hasInt = false
        for (let i = 0; i < planData.length; i++) {
          let selfPrice = isNum(planData[i]._data.selfPrice ) ? planData[i]._data.selfPrice : planData[i]._data.uniformPrice
          //新增意向金判断
          if(planData[i]._data.payTypeFlag == 3){
            selfPrice = planData[i]._data.depositPrice
          }
          if (!hasZero && selfPrice === 0) {
            hasZero = true
          }
          if (!hasInt && selfPrice > 0) {
            hasInt = true
          }
        }
        if (hasZero && hasInt) {
          showToast('存在0元订单，请分开下单')
          return
        }
				//意向金不可与其他一起结算
				const payTypeFlags = planData.map(item=>item.payTypeFlag)
				const noIntentions = payTypeFlags.filter(item=>item!=3)
				if(payTypeFlags.includes(3) && noIntentions.length>0){
				  showToast('意向金订单不可与其他同时结算')
				  return
				}
      }
      // 轮胎产品，同一家经销商可一并结算，非同一家经销商不能结算
      if (tyreData.length) {
        let gsCodeArr = tyreData.map(({ gsCode }) => gsCode)
        let isAllEqual = new Set(gsCodeArr).size === 1
        if (!isAllEqual) {
          errDialogMsg += '<p>轮胎产品应选择同一家经销商进行结算</p>'
        }
        if (planData.length) {
          errDialogMsg += '<p>轮胎订单和致友计划不能同时结算</p>'
        }
        if (totalProductAmount > 4) {
          errDialogMsg += '<p>每单最多只能购买4条轮胎</p>'
        }
        if (errDialogMsg) {
          state.errDialogMsg = errDialogMsg
          state.isShowErrDialog = true
          return
        }
      }
      if (shopData.length) {
        let gsCodeArr = shopData.map(({ gsCode }) => gsCode)
        let isAllEqual = new Set(gsCodeArr).size === 1
        if (!isAllEqual) {
          errDialogMsg += '<p>商品应选择同一家经销商进行结算</p>'
        }
        if (planData.length) {
          errDialogMsg += '<p>商品订单和致友计划不能同时结算</p>'
        }
        if (errDialogMsg) {
          state.errDialogMsg = errDialogMsg
          state.isShowErrDialog = true
          return
        }
      }
      console.log('aaaa')
      return true
    }
    // 重置错误信息
    const closedErrDialog = () => {
      state.errDialogMsg = ''
    }
    // 删除购物车记录
    const deleteSelectFn = async () => {
      // console.log('deleteSelectFn-->', state.result);
      const {
        result: { planData, tyreData,tyrePlanData,shopData }
      } = state
      const planId = planData.map(({ id }) => ({ id }))
      const tyrePlanId = tyrePlanData.map(({ id }) => ({ id }))
      const tyreId = tyreData.map(({ id }) => ({ id }))
      const shopId = shopData.map(({ id }) => ({ id }))
      const allCartId = [...planId, ...tyreId,...tyrePlanId,...shopId]
      if (!allCartId.length) {
        showToast('请选择要删除的商品')
        return
      }
      state.isShowDialog = true
    }
    // 删除购物车商品后处理(静态删除本地数据)
    const afterDelete = (data) => {
      // console.log('afterDelete',data);
      let {
        planData: { list: planList },
        tyreData: { list: tyreList },
        tyrePlanData: { list: tyrePlanList },
        shopData: { list: shopList }
      } = state
      const deleteId = data.filter(item => !item.isEW).map(({ id }) => id)
      const deletedEWId = data.filter(item => item.isEW).map(({ id }) => id)
      let newPlanList = planList.reduce((arr, item) => {
        if (!deleteId.includes(item.id)) {
          arr.push(item)
        }
        return arr
      }, [])
      let newTyreList = tyreList.reduce((arr, item) => {
        if (!deleteId.includes(item.id)) {
          arr.push(item)
        }
        return arr
      }, [])
      let newTyrePlanList = tyrePlanList.reduce((arr, item) => {
        if (!deleteId.includes(item.id)) {
          arr.push(item)
        }
        return arr
      }, [])
      let newShopList = shopList.reduce((arr, item) => {
        if (!item.isEW && !deleteId.includes(item.id) || item.isEW && !deletedEWId.includes(item.id)) {
          arr.push(item)
        }
        return arr
      }, [])
      // console.log('newPlanList',newPlanList);
      state.planData.list = newPlanList
      state.tyreData.list = newTyreList
      state.tyrePlanData.list = newTyrePlanList
      state.shopData.list = newShopList
      state.goodNum = newPlanList.length + newTyreList.length + newShopList.length +newTyrePlanList.length
      store.dispatch('getCountOfShoppingCar')
    }
    // 执行删除购物车商品
    const handleDelete = async (action) => {
      if (action === 'confirm') {
        try {
          const {
            result: { planData, tyreData,tyrePlanData ,shopData }
          } = state
          const planId = planData.map(({ id }) => ({ id }))
          const tyreId = tyreData.map(({ id }) => ({ id }))
          const tyrePlanId = tyrePlanData.map(({ id }) => ({ id }))
          const shopId = shopData.filter(item => !item.isEW).map(({ id }) => ({ id }))
          const allCartId = [...planId, ...tyreId,...tyrePlanId,...shopId]
          if (allCartId.length > 0) {
            await deleteShoppingInf({ data: allCartId })
            // 刷新数据
            afterDelete(allCartId)
          }

          // 删除延保数据并刷新
          const ewShopId = shopData.filter(item => item.isEW).map(({ id, isEW }) => ({ id, isEW }))
          if (ewShopId.length > 0) {
            await deleteEWShopping({ ids: ewShopId.map(({ id }) => (id)).join(',') })
            afterDelete(ewShopId)
          }
          return true
        } catch (e) {
          showToast(e.message, '删除失败')
        }
      }
      if (action === 'cancel') {
        return true
      }
    }

    // 显示确认订单弹窗
    const addShowNum = (data) => {
      console.log(data)
      if (data._data.productType === 1 && data._data.loyaltyTypeFlag==1) {
        state.loyaltyId = data._data.productId
      }
      if (data._data.productType === 2) {
        store.commit('SETCURRENTTYRE', { id: data._data.productId })
      }
      if(data._data.productType === 1 && data._data.loyaltyTypeFlag==2){
        state.loyaltyId = data._data.productId
      }
      // 设置数据到vuex
      setConfirmGoodsStore(
        store,
        Object.assign({}, data._data, {
          imgSrc: data.imgSrc,
          productName: data.productName,
          stock: data._data?.stockAmount || 0
        })
      )
      state.confirmGoodData = data
      nextTick(() => {
        if (data._data.productType === 1 && data._data.loyaltyTypeFlag==1) {
          state.showNum += 1
        }
        if (data._data.productType === 2) {
          state.showTyreNum += 1
        }
        if (data._data.productType === 1 && data._data.loyaltyTypeFlag==2) {
          state.showNum += 1
        }
      })
    }

    //计算总价和商品总数量
    const calculateTotalNum = _.debounce(
      () => {
        nextTick(() => {
          // console.log('calculateTotalNum', state.result)
          const result = Object.values(state.result).flat(Infinity)
          state.totalPrice = result.reduce((total, item) => {
           let price = item.price
           if(item.payTypeFlag==3){
             price = item.depositPrice
           }
           return Math.round(total * 100 + item.num * (price * 100)) / 100
         }, 0)
          state.totalProductAmount = result.reduce((total, item) => {
            return total + item.num
          }, 0)
          // 设置是否显示
          state.isShowDiscount = !!state.result.tyreData.length
          setCouponListParam(state.result.tyreData)
        })
      },
      100,
      { trailing: true }
    )

    // 更新全选状态和已选数据
    const updateCheckAll = (type, bool, v) => {
      // console.log("updateCheckAll-->", type, bool, v);
      let {
        planData: { list: planList },
        tyreData: { list: tyreList },
        tyrePlanData: { list: tyrePlanList },
        shopData: { list: shopList },
      } = state
      const allId = [...planList, ...tyreList,...tyrePlanList,...shopList].map(({ id }) => id)
      let res = v.reduce((arr, item) => {
        if (allId.includes(item.id)) {
          arr.push(item)
        }
        return arr
      }, [])
      if (type) {
        let isCheckAll = state[type].list.length === res.length
        state[type]['checkAll'] = isCheckAll
        state.result[type] = res
        // 轮胎/致友计划，非同一类产品类型不能同时结算，
        // 如选择致友计划产品，先前选择的轮胎产品取消勾选，以最后一次勾选中的产品为准
        const resetTyreData = ()=>{
          if (state.result.tyreData.length) {
            tyreTypeCardRef.value?.clickTitle(false)
            state.result.tyreData = []
            state.tyreData.checkAll = false
          }
        }
        const resetTyrePlanData = ()=>{
          if (state.result.tyrePlanData.length) {
            tyrePlanCardRef.value?.clickTitle(false)
            state.result.tyrePlanData = []
            state.tyrePlanData.checkAll = false
          }
        }
        const resetPlanData = ()=>{
          if (state.result.planData.length) {
            palnTypeCardRef.value?.clickTitle(false)
            state.result.planData = []
            state.planData.checkAll = false
          }
        }
        const resetShopData = ()=>{
          if (state.result.shopData.length) {
            shopTypeCardRef.value?.clickTitle(false)
            state.result.shopData = []
            state.shopData.checkAll = false
          }
        }
        if (res.length) {
          if (type === 'planData') {
            resetTyreData()
            resetShopData()
            resetTyrePlanData()
          }
          if (type === 'tyreData') {
            resetPlanData()
            resetShopData()
            resetTyrePlanData()
          }
          if (type === 'tyrePlanData') {
            resetTyreData()
            resetPlanData()
            resetShopData()
          }
          if (type === 'shopData') {
            resetTyreData()
            resetPlanData()
            resetTyrePlanData()
          }
        }
      }
      nextTick(() => {
        // console.log('updateCheckAll-checkAll->',state.planData.checkAll,state.tyreData.checkAll);
        state.selectAllGoods =
          state.planData.checkAll &&
          state.tyreData.checkAll &&
          state.tyrePlanData.checkAll &&
          state.shopData.checkAll &&
          (!!state.planData.list.length || !!state.tyreData.list.length || !!state.tyrePlanData.list.length|| !!state.shopData.list.length)

        // 计算总价和商品总数量
        calculateTotalNum()
      })
    }
    // 设置所有选择状态
    const setAllStatus = (isChecked) => {
      state.planData.checkAll = isChecked
      state.tyreData.checkAll = isChecked
      state.tyrePlanData.checkAll = isChecked
      state.shopData.checkAll = isChecked
      palnTypeCardRef.value?.clickTitle(isChecked)
      tyreTypeCardRef.value?.clickTitle(isChecked)
      tyrePlanCardRef.value?.clickTitle(isChecked)
      shopTypeCardRef.value?.clickTitle(isChecked)
    }
    // 点击全选
    const checkAllGoods = ({ value }) => {
      // console.log("点击全选-->", value, state.selectAllGoods);
      state.selectAllGoods = value
      nextTick(() => {
        setAllStatus(value)
      })
    }
    //点击管理按钮
    const clickManageBtn = () => {
      state.isManage = !state.isManage
      setAllStatus(false)
    }
    // 获取购物车列表数据信息
    const getShoppingListFn = async () => {
      state.isShowLoad = true
      state.isShowNoData = false
      state.planData = state.tyreData = state.tyrePlanData = state.shopData = {}
      try {
        const data = await getShoppingList()
        const couponDataObj = couponList(data)
        Object.assign(state, couponDataObj)
        state.isShowLoad = false
        let {
          planData: { list: planList = [] } = {},
          tyreData: { list: tyreList = [] } = {},
          tyrePlanData: { list: tyrePlanList = [] } = {},
          shopData: { list: shopList = [] } = {}
        } = couponDataObj
        state.isShowNoData = !(planList.length || tyreList.length || tyrePlanList.length|| shopList.length)
      } catch (e) {
        showToast(e.message, '数据请求失败')
        state.isShowLoad = false
        state.isShowNoData = true
      }
    }
    const refreshShoppingCar = () => {
      state.confirmGoodData = {}
      getShoppingListFn()
    }
    //修改商品数量
    const stepperChangeNum = (data) => {
      let { v, i, type } = data
      // console.log('stepperChangeNum', data, v, i, type, state[type])
      state[type]['list'][i]['num'] = v
    }
    // 获取计划id
    provide('addShowNum', addShowNum)
    provide('updateCheckAll', updateCheckAll)
    provide('deleteSelectFn', deleteSelectFn)
    provide('calculateTotalNum', calculateTotalNum)
    provide('afterDelete', afterDelete)
    provide('stepperChangeNum', stepperChangeNum)
    onMounted(async () => {
      await getShoppingListFn()
    })
    const isShowPaln = computed(
      () => state.planData.list && state.planData.list.length > 0
    )
    const isShowTyre = computed(
      () => state.tyreData.list && state.tyreData.list.length > 0
    )
    const isShowTyrePlan = computed(
      () => state.tyrePlanData.list && state.tyrePlanData.list.length > 0
    )
    const isShowShop = computed(
      () => state.shopData.list && state.shopData.list.length > 0
    )
    // 卸载缓存选中的商品，再次进入要恢复选中
    onBeforeUnmount(async () => {
      const {
        result: { planData, tyreData,tyrePlanData,shopData }
      } = state
      const planId = planData.map(({ id }) => id)
      const tyreId = tyreData.map(({ id }) => id)
      const tyrePlanId = tyrePlanData.map(({ id }) => id)
      const shopId = shopData.map(({ id }) => id)
      store.dispatch('setShoppingCarSelect', {
        planData: planId,
        tyreData: tyreId,
        tyrePlanData: tyrePlanId,
        shopData: shopId,
      })
    })
    // 设置优惠券请求参数
    const setCouponListParam = (data) => {
      // console.log("setCouponListParam", data);
      if (data.length) {
        let tyreIds = []
        let numbers = []
        let gsCodes = []
        let prodPrice = []
        data.map((item) => {
          tyreIds.push(item._data.productId)
          numbers.push(item.num)
          gsCodes.push(item.gsCode)
          prodPrice.push(item.computePrice)
        })
        state.couponListParam = {
          productId: tyreIds.join(','),
          numbers: numbers.join(','),
          gsCodes: _.uniq(gsCodes).join(','),
          minProdPrice:Math.min.apply(Math, prodPrice)
        }
      } else {
        state.couponListParam = null
      }
    }
    //已选的轮胎(供计算默认最大优惠使用)
    const tyreSelectedList = computed(() => {
      if (state.result.tyreData && state.result.tyreData.length) {
        const tyreData = state.result.tyreData
        return tyreData.map(
          ({ _data: { productId: id = '' } = {}, num: count }) => ({
            id,
            count
          })
        )
      }
      return []
    })
    const currentType = computed(() => {
      if (state.result.tyreData && state.result.tyreData.length) {
        return 'tyre'
      }
      if (state.result.tyrePlanData && state.result.tyrePlanData.length) {
        return 'tyrePlan'
      }
      if (state.result.planData && state.result.planData.length) {
        return 'plan'
      }
      if (state.result.shopData && state.result.shopData.length) {
        return 'shop'
      }
      return ''
    })

    return {
      ...toRefs(state),
      toBalance,
      deleteSelectFn,
      checkAllGoods,
      setAllStatus,
      palnTypeCardRef,
      tyreTypeCardRef,
      tyrePlanCardRef,
      shopTypeCardRef,
      clickManageBtn,
      getShoppingListFn,
      isShowPaln,
      isShowTyre,
      isShowTyrePlan,
      isShowShop,
      refreshShoppingCar,
      handleDelete,
      closedErrDialog,
      tyreSelectedList,
      currentType
    }
  }
}
